<div class="container">
    <div class="centered-content">
        <!-- <span style="color: #1650b1;font-weight: 500;">Card Size : 350px * 500px</span><br> -->
        <span style="color: #1650b1;font-weight: 500;">Card Size : 350px * 500px</span><br>
        <p style="color: #1650b1;font-weight: 500;">Image Size : 350px * 240px</p>
        <div class="card" [ngClass]="{'selected': isSelected}">
            <div class="img-background">
                <img class="card-image" [src]="image" (error)=" onImageError($event)" alt="Uploaded Image">
            </div>
            <div class=" card-body">
                <!-- <div class="row" style="margin-bottom: -30px;text-transform: capitalize;font-weight: 700;">
                    <p class="card-title fullname">Participant Name </p>&nbsp;
                </div> -->
                <div class="row text-start">
                    <div class="col-4">
                        <span>Reg ID</span>
                    </div>
                    <div class="col-1">:</div>
                    <div class="col-7">
                        <span>000000</span>
                    </div>
                </div>
                <div class="row text-start">
                    <div class="col-4">
                        <span>Name</span>
                    </div>
                    <div class="col-1">:</div>
                    <div class="col-7">
                        <span>V Think Solution Pvt Ltd</span>
                    </div>
                </div>
                <div class="row text-start">
                    <div class="col-4">
                        <span>Mobile</span>
                    </div>
                    <div class="col-1">:</div>
                    <div class="col-7">
                        <span>1234567890</span>
                    </div>
                </div>
                <div class="row text-start">
                    <div class="col-4">
                        <span>City</span>
                    </div>
                    <div class="col-1">:</div>
                    <div class="col-7">
                        <span>Surat</span>
                    </div>
                </div>
                <div class="row text-start">
                    <div class="col-4">
                        <span>Event Type</span>
                    </div>
                    <div class="col-1">:</div>
                    <div class="col-7">
                        <span>Silver</span>
                    </div>
                </div>
                <div class="row" style="margin-top: 10px;">
                    <div class="col-6">
                        <img src="./assets/qrcode.png" style="height: 100px;width: 100px;">
                    </div>
                    <div class="col-6">
                        <img id="image_path" class="card-img" src='https://aieventzo.com/upload/user.png'>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>